<template>
 <v-card style="margin: auto">
   <v-form v-model="formValid">
       <v-col
         cols="12"
       >
         <v-text-field
           v-model="form.firstName"
           :rules="[rules.maxLength(10)]"
           :counter="10"
           label="Název"
           required
         ></v-text-field>
       </v-col>

       <v-col
         cols="12"
       >
         <v-text-field
           v-model="form.email"
           :rules="[rules.required, rules.email]"
           label="Login"
           required
         ></v-text-field>
       </v-col>
       <v-col
         cols="12"
       >
         <v-text-field
           v-model="form.password"
           label="Heslo"
           :rules="this.item.id ? [] : [rules.required, rules.minLength(6)]"
           :type="show1 ? 'text' : 'password'"
           :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
           @click:append="show1 = !show1"
           required
         ></v-text-field>
       </v-col>
       <v-col
         cols="12"
       >
         <v-text-field
           v-model="form.passwordConfirmation"
           label="Heslo znovu"
           :rules="this.item.id ? [] : [rules.required, formRules.passwordConfirmation]"
           :type="show2 ? 'text' : 'password'"
           :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
           @click:append="show2 = !show2"
           required
         ></v-text-field>
       </v-col>
       <v-col
         cols="12"
       >
         <v-select
           v-model="form.roleId"
           label="Oprávnění"
           :rules="[rules.required]"
           :items="adminRoles"
           item-text="name"
           required
         ></v-select>
       </v-col>
       <v-col
         cols="12"
       >
         <v-btn
           color="primary"
           @click="save"
           label="Uložit"
           :disabled="!formValid || wait"
           required
         >Uložit</v-btn>
       </v-col>
   </v-form>
 </v-card>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'AddAdmin',
  props: ['item'],
  mixins: [rules],
  data () {
    return {
      wait: false,
      adminRoles: [{
        name: 'Superadministrátor',
        value: 1
      },
      {
        name: 'Administrátor',
        value: 2
      },
      {
        name: 'Operátor',
        value: 3
      }],
      show1: false,
      show2: false,
      form: {
        id: this.item.id,
        firstName: this.item.firstName,
        email: this.item.email,
        password: '',
        passwordConfirmation: '',
        roleId: this.item.roleId
      },
      formValid: true,
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      }
    }
  },
  methods: {
    save () {
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/users${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase({
          ...this.form,
          foodTypes: [],
          districts: []
        })
      }
      this.$http(options)
        .then(response => {
          this.wait = false
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 422) {
            alert('E-mail je již používán.')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
